module.exports = __webpack_public_path__ + "images/Acreage_Holdings-30cc42.png";